import { render, staticRenderFns } from "./AlarmGeneralDonutVision.vue?vue&type=template&id=4b3b45f0&scoped=true&"
import script from "./AlarmGeneralDonutVision.vue?vue&type=script&lang=js&"
export * from "./AlarmGeneralDonutVision.vue?vue&type=script&lang=js&"
import style0 from "./AlarmGeneralDonutVision.vue?vue&type=style&index=0&id=4b3b45f0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3b45f0",
  null
  
)

export default component.exports